import angular from 'angular';

const COOKIE_POLICY_COOKIE = 'cookiePolicyAgreed';
const MODULE_NAME = 'cookiePolicy';
const DAYS_IN_YEAR = 365;

class cookiePolicyComponent {
	constructor($cookies) {
		'ngInject';
		this.$cookies = $cookies;
	}

	$onInit() {
		this.hideCookiePolicy = this.$cookies.get(COOKIE_POLICY_COOKIE);
	}

	agree() {
		let now = new Date();
		now.setDate(now.getDate() + DAYS_IN_YEAR);
		this.$cookies.put(COOKIE_POLICY_COOKIE, true, {expires: now});
		this.hideCookiePolicy = true;
	}
}

export default angular.module(MODULE_NAME, []).component('cookiePolicyComponent', {
	controller: cookiePolicyComponent,
	templateUrl: 'cookie-policy.html',
	controllerAs: 'cookiePolicyCtrl'
}).name;


